import PreModerCommentsList from './premoderation-comments-list'

export default PreModerCommentsList
